import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgApexchartsModule } from 'ng-apexcharts';
import { PipeModule } from 'src/app/extensions/pipes/pipe.module';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { DashboardContainerComponent } from './dashboard-container/dashboard-container.component';
import { DashboardContractComponent } from './dashboard-contract/dashboard-contract.component';
import { DashboardRoutingModule } from './dashboard-routing.module';

@NgModule({
  imports: [
    DashboardRoutingModule,
    TranslateModule.forChild(),
    CommonModule,
    NgApexchartsModule,
    PipeModule,
    ComponentsModule,
  ],
  declarations: [DashboardContainerComponent, DashboardContractComponent],
  providers: [DatePipe, DecimalPipe],
})
export class DashboardModule {}
